import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import moment, { invalid } from "moment";
import DateTime from 'react-datetime'
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";

const SEND_NOTIFICATION = gql`
  mutation($params: EducationNotifications) {
    sendEduNotification(params: $params)
  }`

class NotificationModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingSpinner: 0,
            currentStep: 1,
            submitError: ""
        }
    }

    handleFormSubmit = async () => {

        let date = this.props.stateData.getExamPapers.find((item)=> item.value == +this.props.stateData.examName)
        let params = {
            date: date.exam_date,
            exam_paper_id: parseInt(this.props.stateData.examName),
            notification_type: "marks",
        }

        console.log("params", params);

        this.sendEduNotification(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message) })
            setTimeout(() => {
                this.props.onHide();
            }, 5000);
        })
    }

    sendEduNotification = async params => {
        await this.props.sendEduNotification({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.sendEduNotification) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0 });
        this.props.onHide();
        window.location.reload(false);
    };
    render() {
        console.log("stateData", this.props.stateData)
        return (
            <Modal
                {...this.props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                className="notify_modal"
            >
                <Modal.Header closeButton className="notify_header"></Modal.Header>

                <Modal.Body className="p-1">
                    <h5 className="text-center">Are you sure you want to send Notification?</h5>
                </Modal.Body>

                <Modal.Footer variant="white" className="notify_footer">
                    <Row>
                        <Col sm={12}>
                            {this.state.currentStep == 5 ? (
                                <Form.Text className="form-text text-danger mb-2 " style={{ textAlign: "center" }}>
                                    Notification sent successfully
                                </Form.Text>
                            ) : (
                                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                                    {this.state.submitError}
                                </Form.Text>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12} style={{ display: "block", textAlign: "center" }}>
                            <Button className="btn btn-success text-uppercase" onClick={(e) => this.handleFormSubmit()}>
                                {
                                    this.state.loadingSpinner == 1 ? (
                                        <span className="spinner-border spinner-border-sm"></span>
                                    ) : ""
                                }
                                Send</Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default withRouter(withApollo(compose(
    graphql(SEND_NOTIFICATION, {
        name: "sendEduNotification"
    })
)(NotificationModal)));